<template>
    <div class="labeled-control">
      <p :class="{ wm_label_disabled: disabled }">{{ label }}</p>
      <input
        autocomplete="off"
        class="wm_input"
        :id="inputid"
        :placeholder="placeholder"
        :style="{ width: full_length }"
        v-model="displayValue"
        :disabled="disabled"
        :class="{
          wm_input_disabled: disabled,
          wm_input_tightness1: tightness == 1,
          wm_input_tightness2: tightness == 2,
          wm_username_input: username
        }"
        :type="type"
        :min="min"
        :max="max"
        :step="step"
        :maxlength="maxlength"
        :minlength="minlength"
        :hintText="hintText"
        :title="hint"
        @focus="isEditing = true"
        @blur="isEditing = false"
      />
    </div>
  </template>
  
  <script>
  import { _ } from "vue-underscore";
  export default {
    name: "LabeledInputReports",
    props: {
      label: { type: String },
      placeholder: { type: String },
      modelValue: String,
      type: { type: String, default: "text" },
      disabled: { type: Boolean },
      inputid: { default: null },
      width: { default: 150 },
      tightness: { default: 0 },
      step: { default: 1 },
      min: { default: -100000 },
      max: { default: 100000 },
      minlength: { default: "0" },
      maxlength: { default: "524" },
      username: { default: false },
      hintText: { type: String, default: "" },
      // Pass the sidebar open state.
      sidebarOpen: { type: Boolean, default: true },
      // Pass the available objects/tags for templating.
      templateData: { type: Object, default: () => ({}) }
    },
    emits: ['update:modelValue'],
    data() {
      return {
        isEditing: false
      };
    },
    computed: {
      full_length() {
        return this.width.toString() + "px";
      },
      hint() {
        return this.hintText;
      },
      displayValue: {
        get() {
          if (this.isEditing || this.sidebarOpen) {
            return this.modelValue;
          } else {
            return this.processValue(this.modelValue, this.templateData);
          }
        },
        set(newValue) {
          this.$emit('update:modelValue', newValue);
        }
      }
    },
    methods: {
      formatDate(dateString) {
        const d = new Date(dateString);
        const year = d.getFullYear();
        // getMonth() returns 0-indexed month so add 1 and pad with 0 if needed
        const month = ('0' + (d.getMonth() + 1)).slice(-2);
        const day = ('0' + d.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
      },
      // formatDate(isoTimestamp) {
      //   const date = new Date(isoTimestamp); // Parse the ISO timestamp
      //   date.setUTCDate(date.getUTCDate()); // Add one day since when selecting date it is set to 23:00 the day before. So need to round up.
      //   const year = date.getUTCFullYear(); // Get the year
      //   const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Get the month (add 1 because getUTCMonth is zero-based)
      //   const day = String(date.getUTCDate()).padStart(2, "0"); // Get the day
      //   return `${year}-${month}-${day}`; // Format as YYYY-MM-DD
      // },
  
      processValue(raw, data) {
        try {
          if (data.diagram) {
            data.diagram.to_date = this.formatDate(data.diagram.to_date)
            data.diagram.to_date_year_month = this.formatDate(data.diagram.to_date).slice(0, 7);
            data.diagram.to_date_year = this.formatDate(data.diagram.to_date).slice(0, 4);
          
  
            data.diagram.from_date = this.formatDate(data.diagram.from_date)
            data.diagram.from_date_year_month = this.formatDate(data.diagram.from_date).slice(0, 7);
            data.diagram.from_date_year = this.formatDate(data.diagram.from_date).slice(0, 4);
            
          }
          const tpl = _.template(raw, { interpolate: /<\(=([\w.]+)\)>/g });
          return tpl(data) || raw;
        } catch (e) {
          return raw;
        }
      }
    }
  };
  </script>
  